import React, { ChangeEvent } from 'react';
import { useField } from 'formik';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { hasValue } from './inputHelpers';
import CharacterCounter from './CharacterCounter';

interface IProps {
  name: string
  maxLength?: number
}

const XTextInput = ({ name, margin = 'normal', maxLength, ...props }: TextFieldProps & IProps) => {
  const [field, meta] = useField({ name });
  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);

  const handleChange = ({ target:{ value } }:ChangeEvent<any>) => {
    field.onChange({ target: { name, value: hasValue(value) ? value : null } });
  }

  return (
    <>
      <TextField
        {...field}
        onChange={handleChange}
        {...props}
        margin={margin}
        fullWidth
        error={showError}
        helperText={showError && error}
        value={hasValue(field.value) ? field.value : null}
        autoComplete="off"
        inputProps={maxLength ? { ...props.inputProps, maxLength } : props.inputProps}
      />
      {
        maxLength && (
          <CharacterCounter
            currentLength={field.value?.length ?? 0}
            maxLength={maxLength}
          />
        )
      }
    </>
  );
};

export default XTextInput;
